function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useHistory } from 'react-router';
import { Autocomplete, Button, Card, ConfirmationModal, Page, Typography, useGlobalContext } from 'seagull';
import { routes } from "../../../constants";
import { selectors } from "../../../store/state-selectors";
import { useOnMount } from "../../../hooks/useOnMount";
import { getPMDetails } from "../pm.utils";
import ExternalLinkButton from "../../../components/ExternalLinkButton";
import { integrationModel } from "../../../models";
import { useStore, useStoreActions } from "../../../contexts";
import { getHelpArticle, handlePromise } from "../../../infra/utils";
import PMMapServicesModal from "../PMMapServicesModal/PMMapServicesModal";
import { IntegrationSource, isPracticeManagementIntegrationItem } from "../../../types/api.model";
import styles from "./PMSetupPage.module.scss";
export default function PMSetupPage(props) {
  const {
    pmName,
    testid,
    integration,
    doDisconnect,
    getItems,
    linkServiceTemplate,
    getServiceTemplateIntegratedIds
  } = props;
  const history = useHistory();
  const {
    showModal,
    showErrorToast,
    showSuccessToast,
    startLoader,
    stopLoader
  } = useGlobalContext();
  const {
    fetchIntegrations,
    fetchKarbonIntegration,
    fetchKarbonUsers,
    api
  } = useStoreActions();
  const karbonUsers = useStore(selectors.integration.karbonUsers);
  const renderCard = (text, action) => /*#__PURE__*/React.createElement(Card, {
    autoHeight: true,
    padding: "m"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.cardContent
  }, text, action));
  useOnMount(() => {
    if (pmName === IntegrationSource.Karbon) fetchKarbonUsers();
  });
  async function disconnect() {
    const confirmed = await showModal({
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        const cancel = () => dismissModal(false);
        return /*#__PURE__*/React.createElement(ConfirmationModal, {
          "data-testid": "confirm-disconnect-modal",
          skin: "danger",
          title: "Disconnect from ".concat(getPMDetails(pmName).name),
          content: /*#__PURE__*/React.createElement(Typography, null, "Are you sure you want to disconnect from ", getPMDetails(pmName).name, "?"),
          primaryButtonLabel: "Disconnect",
          secondaryButtonLabel: "Cancel",
          onPrimaryButtonClick: () => dismissModal(true),
          onSecondaryButtonClick: cancel,
          onCloseButtonClick: cancel
        });
      }
    });
    if (!confirmed) return;
    const disconnectLoader = 'disconnect';
    startLoader(disconnectLoader);
    const result = await handlePromise(doDisconnect());
    if (result.success) {
      await fetchIntegrations();
      goBack();
    } else {
      showErrorToast('Failed to disconnect', 'failed-to-disconnect-toast');
    }
    stopLoader(disconnectLoader);
  }
  async function mapServices() {
    showModal({
      content: p => /*#__PURE__*/React.createElement(PMMapServicesModal, _extends({
        pmName: pmName,
        getItems: getItems,
        linkServiceTemplate: linkServiceTemplate,
        getServiceTemplateIntegratedIds: getServiceTemplateIntegratedIds
      }, p))
    });
  }
  function goBack() {
    history.push(routes.integrations);
  }
  return /*#__PURE__*/React.createElement(Page, {
    "data-testid": testid,
    header: "".concat(getPMDetails(pmName).name, " integration setup"),
    subheader: /*#__PURE__*/React.createElement(React.Fragment, null, "Set up your ", getPMDetails(pmName).name, " account connection.", ' ', /*#__PURE__*/React.createElement(ExternalLinkButton, {
      openInNewTab: true,
      href: getHelpArticle(getPMDetails(pmName).articleLink)
    }, "Learn more")),
    onClickBack: goBack
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.cards
  }, renderCard( /*#__PURE__*/React.createElement(Typography, null, "Map and assign Anchor services to ", getPMDetails(pmName).name, " items"), /*#__PURE__*/React.createElement(Button, {
    "data-testid": testid && "".concat(testid, "-map-services"),
    className: styles.actionButton,
    onClick: mapServices
  }, "Map services")), pmName === IntegrationSource.Karbon && karbonUsers && integration && integrationModel.isLinked(integration) && renderCard( /*#__PURE__*/React.createElement(Typography, null, "Set a default Work assignee"), /*#__PURE__*/React.createElement(Autocomplete, {
    selectOnFocus: true,
    disableClearable: true,
    multiple: false,
    size: "small",
    "data-testid": "default-work-assignee",
    options: karbonUsers,
    getOptionLabel: option => option.name,
    value: karbonUsers.find(user => user.id === integrationModel.karbonDefaultAssignee(integration)),
    textFieldProps: {
      minWidth: '240px'
    },
    onChange: async (e, value) => {
      if (!value || !isPracticeManagementIntegrationItem(value)) return;
      const result = await handlePromise(api.karbon.updateKarbonIntegration(value.id));
      if (result.success) {
        await fetchKarbonIntegration();
        showSuccessToast('Default assignee updated successfully', "karbon-assignee-success-toast");
      } else {
        showErrorToast('Failed to update default assignee', "karbon-assignee-error-toast");
      }
    }
  })), renderCard( /*#__PURE__*/React.createElement(Typography, {
    skin: "error"
  }, "Disconnect from ", getPMDetails(pmName).name), /*#__PURE__*/React.createElement(Button, {
    "data-testid": testid && "".concat(testid, "-disconnect"),
    className: styles.actionButton,
    skin: "danger",
    onClick: disconnect
  }, "Disconnect"))));
}